import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/chevron-right.svg'
import _imports_1 from '../../assets/checkbox-blank.svg'
import _imports_2 from '../../assets/checkbox-marked.svg'


const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "wrap" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "text"
}
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "row tail" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "text"
}
const _hoisted_13 = {
  key: 1,
  class: "text"
}
const _hoisted_14 = { class: "row tail" }
const _hoisted_15 = {
  key: 0,
  class: "title"
}
const _hoisted_16 = {
  key: 1,
  class: "content"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row tail" }
const _hoisted_20 = {
  key: 2,
  class: "protocol"
}
const _hoisted_21 = { class: "text" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]

import { reactive, ref, onMounted } from "vue"
import { getAppLink, sumbitOrder, fetchSystemLink } from "@/utils/api"
import { getUrlParam, observeHeight, safeParseInt, safeRouter } from '@/utils/util'

import Address from '@/components/address.vue'
import Protocol from '@/components/protocol/index.vue'
import DialogMobile from '@/components/number.vue'
import DialogSuccess from '@/components/success.vue'
import DialogText from '@/components/textdialog.vue'
import FloatNav from '@/components/floatnav.vue'

import ModalDialog from '@/components/modal.vue'
import AdView from '@/components/ad.vue'

import Loading from '@/components/loading.vue'
import { toast } from "@/components/toast"

import Track from "@/components/track/cmcc"

import router from "@/router"
import store from "@/store"

interface FormData {
    /** 姓名 */
    name: string;
    /** 身份证号 */
    id: string;
    /** 联系电话 */
    contact: string;
    /** 选中的手机号 */
    mobile: string;
    /** 地址明文 */
    region: string;
    /** 地址 id */
    regionId: string;
    /** 详细地址 */
    detail: string;
}
interface ProtocalData {
    type: string;
    show: boolean;
}
interface AddressData {
    province: LocationTiny;
    city: LocationTiny;
    area: LocationTiny;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


const param = reactive({
    /** 链接ID */
    lid: 0,
    /** 应用ID */
    id: 0
})
const info = ref<AppLinkRsp | undefined>(undefined)
const userAddr = ref<AddressData>()
const state = reactive({
    hasCheckProtocol: false,
    height: '',
    appName: '',
    showQuery: false,
    showError: false,
    errText: '',
    errTitle: '',
    showSuccess: false,
    showAddress: false,
    showMobile: false,
    loading: false,
    isCmcc: true,
    isCucc: false,
    shortUrl: '',
    showAd: false,
    showText: false,
    text: '',
    textTitle: '',
    infoUrl: '',
    /** 客服位置类型: 1 单页, 2 页内 */
    infoType: 0,
    linkName: '',
})
const form = reactive<FormData>({
    id: '',
    name: '',
    contact: '',
    mobile: '',
    region: '',
    regionId: '',
    detail: ''
})
const prot = reactive<ProtocalData>({
    type: '',
    show: false,
})
onMounted(() => {
    observeHeight(this)
    const lidStr = getUrlParam('lid')
    if (lidStr) {
        param.lid = safeParseInt(lidStr)
    }
    const idStr = getUrlParam('id')
    if (idStr) {
        param.id = safeParseInt(idStr)
    }
    fetchDetail()
})

const redirectToLink = async () => {
    const rsp = await fetchSystemLink()
    if (rsp.result == 0 && rsp.data.link) {
        window.location.replace(rsp.data.link)
    }
}
const fetchDetail = async () => {
    state.loading = true
    const rsp = await getAppLink(param.lid, param.id)
    state.loading = false
    if (rsp.result == 0) {
        const { data } = rsp
        info.value = data
        const title = document.querySelector('title')
        if (title) {
            title.innerText = data.display
        }
        state.appName = data.display
        state.isCmcc = data.is_cmcc
        state.isCucc = data.is_cucc
        state.showAd = data.show_ad
        state.infoUrl = data.info_url
        state.infoType = data.info_type
        state.linkName = data.link_name
        param.id = data.id
        store.commit('setInfo', data)
        if (data.is_cmcc) {
            console.log(data.app)
            Track.setAppInfo(data.app)
            setTimeout(() => {
                Track.bussiness(state.isCmcc, '页面浏览', '', '')
            }, 2000)
        }
    } else {
        state.errText = rsp.message
        state.errTitle = '获取数据失败'
        state.showError = true
        redirectToLink()
    }
}

const locationItem2Tiny = (data: LocationItem): LocationTiny => {
    return { id: data.id, name: data.name, code: data.code }
}
const onLocation = ({ success, data }: OnLocationResult) => {
    if (success) {
        if (data.length == 3) {
            userAddr.value = {
                province: locationItem2Tiny(data[0]),
                city: locationItem2Tiny(data[1]),
                area: locationItem2Tiny(data[2])
            }
            Track.bussiness(state.isCmcc, '选择收货省市', form.contact, '')
        }
        form.region = data.map(tmp => tmp.name).join('-')
        form.regionId = data.map(tmp => tmp.id).filter(id => id > 0).join('-')
        state.showAddress = false;
    } else {
        state.showAddress = false;
    }
}
const onMobile = (data: MobileItem | undefined) => {
    state.showMobile = false
    if (data) {
        form.mobile = data.mobile

    }
}
const onSuccess = () => {
    state.showSuccess = false
    state.showText = false
}
const onErrorClose = () => {
    state.showError = false
}
const showAddress = () => {
    state.showAddress = true
}
const submit = async () => {
    if (!state.hasCheckProtocol) {
        toast('请先阅读并同意购卡协议')
        return
    }
    console.log(JSON.stringify(form))
    Track.bussiness(state.isCmcc, '提交订单', form.contact, '')
    const data = {
        id: info.value?.id,
        id_no: form.id,
        name: form.name,
        contact: form.contact,
        address: JSON.stringify(userAddr.value),
        detail: form.detail,
        mobile: form.mobile,
        lid: param.lid,
        referer: window.location.href,
    }
    try {
        state.loading = true
        const rsp = await sumbitOrder(data)
        state.loading = false
        if (rsp.result == 0) {
            // 显示下单成功订单
            state.shortUrl = rsp.data.url
            state.showSuccess = true
            form.mobile = '' // 清空选中手机号
            Track.bussiness(state.isCmcc, '提交订单成功', form.contact, '')
        } else {
            state.errText = rsp.message
            state.errTitle = '下单失败'
            state.showError = true
            state.showQuery = false
            if (rsp.result == 100013) { // 亲，您有一张上门激活订单正常配送，请激活完成后再选购号卡吧。(b03)
                state.showQuery = true
            }
            Track.bussiness(state.isCmcc, '提交订单失败', form.contact, '', rsp.message)
        }
    } catch (e) {
        console.log(e)
        state.loading = false
        state.errText = JSON.stringify(e)
        state.errTitle = '网络请求错误'
        state.showError = true
        Track.bussiness(state.isCmcc, '提交订单失败', form.contact, '', '网络请求错误')
    }

}
const showProtocol = (item: StringItem) => {
    prot.type = item.value
    setTimeout(() => {
        prot.show = true
    }, 0)
    console.log(JSON.stringify(item))
}
const checkProtocol = () => {
    state.hasCheckProtocol = !state.hasCheckProtocol
    console.log('check')
}
const onClickMObile = () => {
    state.showMobile = true
}
const onInputContact = () => {
    Track.bussiness(state.isCmcc, '输入联系电话', form.contact, '')
}
const onInputId = () => {
    Track.bussiness(state.isCmcc, '输入身份证', form.contact, '')
}
const onInputDetail = () => {
    Track.bussiness(state.isCmcc, '填写详细地址', form.contact, '')
}
const onInputName = () => {
    Track.bussiness(state.isCmcc, '输入姓名', form.contact, '')
}
const toQueryPageByModal = () => {
    const p = {
        ...param,
        uid: form.id,
        name: form.name,
    }
    safeRouter(router, 'query', p)
}
const onShowCuccTips = () => {
    const text = "首月按天计费指月基本费按日计扣（入网当日到月底），套餐内包含国内通用流量和语音分钟数按天折算，向上取整。从次月起恢复正常。“首月”指号码激活认证成功当月。";
    // toast(text)
    state.textTitle = '按天付费说明'
    state.text = text;
    state.showText = true;
}
/**
 * 显示 link 名称
 */
const onClickAppName = () => {
    if(state.linkName) {
        toast(`链接名: ${state.linkName}, id: ${param.lid}`)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "page",
    style: _normalizeStyle({ minHeight: state.height })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value?.header, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: index
      }, [
        _createElementVNode("img", {
          src: item,
          alt: "顶部介绍信息"
        }, null, 8, _hoisted_1)
      ]))
    }), 128)),
    (state.infoUrl != ''&&state.infoType == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: state.infoUrl,
            alt: "介绍信息"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_4, [
      (state.appName)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "app-name",
            onDblclick: onClickAppName
          }, "您已选择“" + _toDisplayString(state.appName) + "”", 33))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "title" }, "选择号码", -1)),
        _createElementVNode("div", _hoisted_6, [
          (state.isCucc)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "row",
                onClick: onShowCuccTips
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "required" }, " ", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label highline" }, "首月资费", -1)),
                (form.region == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "按天付费"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (info.value != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "required" }, "*", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "号码归属地", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(info.value.province.name) + " - " + _toDisplayString(info.value.city.name), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "required" }, "*", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label" }, "号码选择", -1)),
            (form.mobile == '')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "text",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickMObile()))
                }, "点击选择号码"))
              : _createCommentVNode("", true),
            (form.mobile != '')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickMObile()))
                }, _toDisplayString(form.mobile), 1))
              : _createCommentVNode("", true),
            _cache[13] || (_cache[13] = _createElementVNode("img", {
              class: "next",
              src: _imports_0
            }, null, -1))
          ])
        ]),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "title" }, [
          _createTextVNode("收货信息"),
          _createElementVNode("span", null, "免费配送,无配送费！")
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "row",
            onClick: showAddress
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "required" }, "*", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label" }, "收货地区", -1)),
            (form.region == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "点击选择"))
              : _createCommentVNode("", true),
            (form.region != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(form.region), 1))
              : _createCommentVNode("", true),
            _cache[16] || (_cache[16] = _createElementVNode("img", {
              class: "next",
              src: _imports_0
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "required" }, "*", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "label" }, "详细地址", -1)),
            _withDirectives(_createElementVNode("input", {
              onFocus: onInputDetail,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.detail) = $event)),
              type: "text",
              class: "input",
              placeholder: "街道/镇+村/小区/写字楼+门牌号"
            }, null, 544), [
              [_vModelText, form.detail]
            ])
          ])
        ]),
        (form.detail != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "入网信息（根据国家实名制要求, 请精准提供身份证信息）"))
          : _createCommentVNode("", true),
        (form.detail != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "required" }, "*", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "label" }, "姓名", -1)),
                _withDirectives(_createElementVNode("input", {
                  onFocus: onInputName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.name) = $event)),
                  type: "text",
                  class: "input",
                  placeholder: "请输入你的姓名"
                }, null, 544), [
                  [_vModelText, form.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "required" }, "*", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label" }, "身份证号", -1)),
                _withDirectives(_createElementVNode("input", {
                  onFocus: onInputId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.id) = $event)),
                  type: "text",
                  class: "input",
                  placeholder: "请输入你的身份证号"
                }, null, 544), [
                  [_vModelText, form.id]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "required" }, "*", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "label" }, "联系电话", -1)),
                _withDirectives(_createElementVNode("input", {
                  onFocus: onInputContact,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.contact) = $event)),
                  type: "number",
                  class: "input",
                  placeholder: "请输入联系电话"
                }, null, 544), [
                  [_vModelText, form.contact]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "btn",
          onClick: submit
        }, "提交订单"),
        (info.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (!state.hasCheckProtocol)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "check",
                    onClick: checkProtocol,
                    src: _imports_1
                  }))
                : _createCommentVNode("", true),
              (state.hasCheckProtocol)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "check",
                    onClick: checkProtocol,
                    src: _imports_2
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _cache[25] || (_cache[25] = _createTextVNode("我已阅读并同意 ")),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.protocol, (pro, pIndex) => {
                  return (_openBlock(), _createElementBlock("span", {
                    onClick: ($event: any) => (showProtocol(pro)),
                    key: pIndex
                  }, _toDisplayString(pro.name), 9, _hoisted_22))
                }), 128)),
                _cache[26] || (_cache[26] = _createTextVNode(" 所有条款 "))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (prot.show)
      ? (_openBlock(), _createBlock(Protocol, {
          key: 1,
          type: prot.type,
          onOnClose: _cache[6] || (_cache[6] = ($event: any) => (prot.show = false))
        }, null, 8, ["type"]))
      : _createCommentVNode("", true),
    (info.value && info.value.vendor)
      ? (_openBlock(), _createBlock(Address, {
          key: 2,
          onResult: onLocation,
          aid: param.id,
          show: state.showAddress,
          type: info.value?.vendor
        }, null, 8, ["aid", "show", "type"]))
      : _createCommentVNode("", true),
    (state.showMobile && info.value)
      ? (_openBlock(), _createBlock(DialogMobile, {
          key: 3,
          onResult: onMobile,
          id: info.value.id
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    (state.showSuccess)
      ? (_openBlock(), _createBlock(DialogSuccess, {
          key: 4,
          onResult: onSuccess,
          url: state.shortUrl
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (state.showError)
      ? (_openBlock(), _createBlock(ModalDialog, {
          key: 5,
          onToQuery: toQueryPageByModal,
          query: state.showQuery,
          title: state.errTitle,
          onResult: onErrorClose,
          text: state.errText
        }, null, 8, ["query", "title", "text"]))
      : _createCommentVNode("", true),
    (state.showAd)
      ? (_openBlock(), _createBlock(AdView, {
          key: 6,
          class: "ad-view",
          position: "详情页"
        }))
      : _createCommentVNode("", true),
    (state.showText)
      ? (_openBlock(), _createBlock(DialogText, {
          key: 7,
          onResult: onSuccess,
          text: state.text,
          title: state.textTitle
        }, null, 8, ["text", "title"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value?.body, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: index
      }, [
        _createElementVNode("img", { src: item }, null, 8, _hoisted_23)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value?.footer, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: index
      }, [
        _createElementVNode("img", { src: item }, null, 8, _hoisted_24)
      ]))
    }), 128)),
    (state.loading)
      ? (_openBlock(), _createBlock(Loading, { key: 8 }))
      : _createCommentVNode("", true),
    (state.appName)
      ? (_openBlock(), _createBlock(FloatNav, {
          key: 9,
          start: false
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})